import type { UploadFileState, UploadJobProgress } from "./types";

// 잡 진행률 집계. 바이트 가중 정책의 단일 소유자다.
//
// Owns:
// - loaded 정의: 확정 바이트(uploaded+skipped) + 전송 중(in-flight) 바이트. skipped 를 포함하므로
//   재개 직후 진행률이 0% 가 아니라 실제 위치에서 시작한다.
// - percent 반올림, 0바이트 잡(빈 파일만) 처리.
//
// Does not own:
// - 파일 상태 전이(UploadEngine), 표시 포맷(UI).

export function aggregateProgress(
  files: readonly UploadFileState[],
  inFlightLoaded: ReadonlyMap<string, number>,
): UploadJobProgress {
  let totalBytes = 0;
  let settledBytes = 0;
  let uploadedFiles = 0;
  let skippedFiles = 0;
  let failedFiles = 0;
  for (const file of files) {
    totalBytes += file.sizeBytes;
    if (file.status === "uploaded") {
      uploadedFiles += 1;
      settledBytes += file.sizeBytes;
    } else if (file.status === "skipped") {
      skippedFiles += 1;
      settledBytes += file.sizeBytes;
    } else if (file.status === "failed") {
      failedFiles += 1;
    }
  }
  let inFlightBytes = 0;
  for (const loaded of inFlightLoaded.values()) {
    inFlightBytes += loaded;
  }
  const loadedBytes = Math.min(totalBytes, settledBytes + inFlightBytes);
  return {
    totalBytes,
    loadedBytes,
    percent: totalBytes === 0 ? 100 : Math.min(100, Math.round((loadedBytes / totalBytes) * 100)),
    totalFiles: files.length,
    uploadedFiles,
    skippedFiles,
    failedFiles,
  };
}
